<template>
  <b-card
    title="مدیریت گمرک ها"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                :to="{ name: 'addcustoms'}"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="نوع گمرک"
                  label-for="Type"
                >
                  <z-customs-type
                    v-model="filterOptions.Type"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="استان"
                  label-for="StateId"
                >
                  <z-state
                    v-model="filterOptions.StateId"
                    :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="IsActive"
                >
                  <v-select
                    v-model="filterOptions.IsActive"
                    :options="enums('IsActive')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updatecustoms', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(City)="data">
            <span v-if="data.value">
              <!-- {{ data.value.Title }} -->
              <b-badge
                v-if="data.value.State"
                variant="light-secondary"
              >
                {{ data.value.State.Title }}
              </b-badge>
            </span>
          </template>

          <template #cell(Type)="data">
            <b-badge
              v-for="item in data.value"
              :key="item"
              variant="light-primary"
              style="line-height: unset; margin: 2px;"
            >
              {{ typeTitle(item) }}
            </b-badge>
          </template>

          <template #cell(IsActive)="data">
            <b-badge
              :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updatecustoms', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>
  </b-card>
</template>

<script>

import ZState from '@/tools/state.vue'
import ZCustomsType from '@/tools/customs/customstype.vue'

export default {
  name: 'Customs',
  components: { ZState, ZCustomsType },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      customsTypes: [],
      filterOptions: {
        Title: null,
        Type: [],
        StateId: null,
        IsActive: null,
        Page: 1,
        PerPage: 10,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'City',
          label: 'استان',
        },
        {
          key: 'Type',
          label: 'نوع گمرک',
        },
        {
          key: 'Visit',
          label: 'بازدید',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.loadCustomsTypes()
    this.update()
  },
  methods: {
    loadCustomsTypes() {
      this.$http.post(
        this.$api.customstype.getall, {},
      )
        .then(res => {
          this.customsTypes = res.data
        })
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.customs.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    typeTitle(value) {
      const item = this.customsTypes.find(x => x.Id === value)
      return item ? item.Title : value
    },
    remove(id) {
      this.removeRow(this.$api.customs.remove, 'Id', id)
    },
  },
}
</script>
